import * as React from 'react';
import { fieldCopy, DisplayType } from '../types/FieldCopy';
import './style/index.scss';
export class EmployeeFieldInformation extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (!this.props.selectedField || !fieldCopy[this.props.selectedField]) {
            return null;
        }
        const { selectedField } = this.props;
        const copy = fieldCopy[selectedField];
        const body = copy[DisplayType.Body];
        const subHeader = copy[DisplayType.SubHeader];
        const listItems = copy[DisplayType.ListItems];
        return (React.createElement("div", { className: "employee-field-information" },
            React.createElement("div", { className: "employee-field-information__header" }, "Why is this field important?"),
            React.createElement("div", { className: "employee-field-information__body" }, body),
            subHeader &&
                React.createElement("div", { className: "employee-field-information__sub-header" }, subHeader),
            !!listItems.length &&
                React.createElement("ul", { className: "employee-field-information__list-items" }, listItems.map((item, index) => {
                    return (React.createElement("li", { className: "information-item", key: index }, item));
                }))));
    }
}
export default { EmployeeFieldInformation };
